import { I18nService } from '../../shared/i18n/i18n.service';
import { DashboardService } from '../../features/dashboard/services/dashboard/dashboard.service';
import { COMMAND_PALETTE_PAGES } from './command-palette-pages';

const DASHBOARD_PATH = /^\/dashboard\/([^/?#]+)/;

/**
 * A tab's title for a bare in-app path: its command-palette page's label, a
 * dashboard's name, or else the path itself — a url carries no title of its
 * own. Dashboards are looked up in the project's list and in the admin
 * "All dashboards" one, since either can have opened the page. Shared by
 * `~usetabs` and the Ctrl+Alt+P "keep this page as a tab" shortcut. A label whose namespace isn't loaded yet falls back to the path,
 * since `I18nService.t()` throws for a scope still loading.
 */
export function tabTitleFor(
  url: string,
  i18n: I18nService,
  dashboards: Pick<DashboardService, 'dashboardList' | 'allDashboardList'>,
): string {
  const path = url.split(/[?#]/)[0];
  const page = COMMAND_PALETTE_PAGES.find((p) => p.route === path);
  if (page && i18n.getScopeReady(page.namespace)()) {
    return i18n.t(page.labelKey, page.namespace);
  }
  const dashboardId = DASHBOARD_PATH.exec(url)?.[1];
  const dashboard = dashboardId
    ? [...dashboards.dashboardList(), ...dashboards.allDashboardList()].find(
        (d) => d.id === dashboardId,
      )
    : undefined;
  return dashboard?.name ?? url;
}
